import { formatCategoryParentPath } from './formatCategoryLabel';

export const BACK_ITEM_ID = '__category_back__';

export const getImmediateParentLabel = (fullName, name) => {
  const parentPath = formatCategoryParentPath(fullName, name);
  if (!parentPath) return '';

  const segments = parentPath.split(' / ').filter(Boolean);
  return segments[segments.length - 1] || '';
};

export const mapCategoryToDropdownItem = (category, { isSearchResult = false } = {}) => {
  const isExpandable = category.type === 'root' || category.type === 'node';
  const parentPathLabel = isSearchResult
    ? getImmediateParentLabel(category.fullName, category.name)
    : '';

  return {
    _id: category._id,
    title: category.name,
    isExpandable,
    showChevron: isExpandable,
    parentPathLabel,
    category,
  };
};

export const buildBrowseDropdownItems = ({
  categories = [],
  showBack = false,
  backTitle,
}) => {
  const items = categories.map((category) => mapCategoryToDropdownItem(category));

  if (!showBack) return items;

  return [{
    _id: BACK_ITEM_ID,
    title: backTitle,
    isBack: true,
    showChevron: false,
    parentPathLabel: '',
  }, ...items];
};

export const toCategoryValue = (category) => {
  if (!category?._id) return null;

  return {
    _id: category._id,
    name: category.name,
    fullName: category.fullName || null,
  };
};
